export default __webpack_public_path__ + "7c8accca91d7d0c99f0dc78f10e72813.png";